import {request} from './request'

// token
function getHeader() {
    const header = JSON.parse(localStorage.getItem('token'))
    // console.log(_token);
    // const header = {token : _token.token}

    return header
}
//用户个人报告  新加    headers({token})         
export function getUser_report(token) {
    return request({ 
        url:'/api/user/report',
        method: 'GET',
        headers:token
    })
}


//帮助列表   params{*limit,page,is_rand,category_id,keyword}
export function getHelp_list(params) {
    return request({ 
        url:'/api/article/help_list',
        method: 'GET',
        params,
        headers:getHeader()
    })
}

//帮助分类
export function getHelp_category() {
    return request({ 
        url:'/api/article/help_category',
        method: 'GET',
        // headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}
        headers:getHeader()
    })
}

//文章列表   params{*page,*limit,category_id,category_id}
export function getArticle_list(params) {
    return request({ 
        url:'/api/article/list',
        method: 'GET',
        params,
        headers:getHeader()
    })
}

//文章详细    params(*id)
export function getArticle_detail(params) {
    return request({ 
        url:'/api/article/detail/'+params,
        method: 'GET',
        
    })
}

//微阅读列表
export function getLink_list() {
    return request({ 
        url:'/api/link/list',
        method: 'GET',
        headers:getHeader()
    })
}

//记录点击次数
export function getLink_hist(params) {
    return request({ 
        url:'/api/link/hits/'+params,
        method: 'GET',
        headers:getHeader()
    })
}

//===================
//图书选购添加   params*(name,press,press_year,lang,isbn,reason,banner)
export function getRecommend_add(params) {
    return request({ 
        url:'/api/book_recommend/add',
        method: 'POST',
        data:params,
        headers:getHeader()
    })
}

//图书选购列表   params*(page,limit)
export function getRecommend_list(params) {
    return request({ 
        url:'/api/book_recommend/list',
        method: 'GET',
        params,
        headers:getHeader()
    })
}

//图书选购想看、取消   params*(id)
export function getRecommend_see(params) {
    return request({ 
        url:'/api/book_recommend/want_to_see',
        method: 'POST',
        data:params,
        headers:getHeader()
    })
}

//图书选购详情   params*(id)
export function getRecommend_detail(params) {
    return request({ 
        url:'/api/book_recommend/detail/'+params,
        method: 'GET',

        headers:getHeader()
    })
}

//图书选购封面上传   params*(file)
export function getRecommend_upload(params) {
    return request({ 
        url:'/api/book_recommend/upload',
        method: 'POST',
        data:params,
        headers:getHeader()
    })
}

//查询是否存在荐购   params*(file)
export function getRecommend_search(params) {
    return request({ 
        url:'/api/book_recommend/search',
        method: 'GET',
        params,
        headers:getHeader()
    })
}

//查询是否存在荐购   params*(file)
export function my_book_list(params) {
    return request({ 
        url:'/api/book_recommend/my_book_list',
        method: 'GET',
        params,
        headers:getHeader()
    })
}

///============

//通知列表   params*(page,limit)
export function getNotice_list(params) {
    return request({ 
        url:'/api/notice/list',
        method: 'GET',
        params,
        headers: getHeader()
    })
}

//通知详情   params*(id)
export function getNotice_detail(params) {
    return request({ 
        url:'/api/notice/detail/'+params,
        method: 'GET',
        headers: getHeader()
    })
}

//存包柜预约-首次  
export function getLocker_signup() {
    return request({ 
        url:'/api/locker/sign_up',
        method: 'POST',
        headers: getHeader(),
    })
}

//存包柜预约详情  
export function getLocker_index() {
    return request({ 
        url:'/api/locker/index',
        method: 'GET',
        headers: getHeader()
    })
}

//存包柜预约取消
export function getLocker_cancel() {
    return request({ 
        url:'/api/locker/cancel',
        method: 'POST',
        headers: getHeader()
    })
}

//存包柜中奖结果  
export function getLocker_result() {
    return request({ 
        url:'/api/locker/draw_result',
        method: 'GET',
        headers: getHeader()
    })
}

//存包柜二次预约     
export function getLocker_again() {
    return request({ 
        url:'/api/locker/again_sign_up',
        method: 'POST',
        headers: getHeader()
    })
}

//获取授权页链接    params(*back_url)
export function getLogin_url(params) {
    return request({ 
        url:'/api/login/get_target_url',
        method: 'POST',
        data:params,
        // headers: {'Content-Type': 'application/json'}
    })
}

//授权登录获取token    params(*code)
export function getLogin_token(params) {
    return request({ 
        url:'/api/login/login',
        method: 'POST',
        data:params,
        
    })
}

//我的信息 用户个人信息    headers({token})          //暂时-第一页面无法拿到header
export function getUser_info(token) {
    return request({ 
        url:'/api/user/info',
        method: 'GET',
        headers:token
    })
}

//绑定aleph账号    parans*()
export function getBind_aleph(params) {
    return request({ 
        url:'/api/user/bind_aleph',
        method: 'POST',
        data:params,
        headers:getHeader()
    })
}

//解绑aleph账号    
export function getUnbind_aleph() {
    return request({ 
        url:'/api/user/unbind_aleph',
        method: 'POST',
        headers: getHeader()
    })
}

//修改aleph密码     params(original_password,new_password,new_password_confirm)
export function getChange_password(params) {
    return request({ 
        url:'/api/user/change_password',
        method: 'POST',
        data:params,
        headers:getHeader()
    })
}

//修改电子邮箱
export function getChange_email(params) {
    return request({ 
        url:'/api/user/change_email',
        method: 'POST',
        data:params,
        headers:getHeader()
    })
}
//发送电子邮件
export function send_email(params) {
    return request({ 
        url:'/api/user/sendEmail',
        method: 'POST',
        data:params,
        headers:getHeader()
    })
}

//绑定手机号
export function getChange_phone(params) {
    return request({ 
        url:'/api/user/change_phone',
        method: 'POST',
        data:params,
        headers:getHeader()
    })
}

//修改手机号
export function getChange_phone2(params) {
    return request({ 
        url:'/api/user/change_phone2',
        method: 'POST',
        data:params,
        headers:getHeader()
    })
}
//发送验证码
export function sendmsg(params) {
    return request({ 
        url:'/api/user/sendmsg',
        method: 'POST',
        data:params,
        headers:getHeader()
    })
}

//讲座列表     params*(page,limit,is_history)
export function getLecture_list(params) {
    return request({ 
        url:'/api/lecture/list',
        method: 'GET',
        params,
        headers:getHeader()
    })
}

//讲座详情     params*({id})
export function getLecture_detail(params) {
    return request({ 
        url:'/api/lecture/detail/'+params,
        method: 'GET',
        headers: getHeader()
    })
}

//讲座报名     params*(lecture_id)
export function getLecture_enroll(params) {
    return request({ 
        url:'/api/lecture/enroll',
        method: 'POST',
        data:params,
        headers: getHeader()
    })
}

//讲座报名列表     params*(lecture_id,page,limit)
export function getLecture_enroll_list(params) {
    return request({ 
        url:'/api/lecture/enroll_list',
        method: 'GET',
        params,
        headers: getHeader()
    })
}

//讲座关注与取消关注    params*(lecture_id)
export function getLecture_follow(params) {
    return request({ 
        url:'/api/lecture/follow',
        method: 'POST',
        data:params,
        headers: getHeader()
    })
}

//讲座评论添加    params*(lecture_id,content)
export function getLecture_comment_add(params) {
    return request({ 
        url:'/api/lecture/comment_add',
        method: 'POST',
        data:params,
        headers: getHeader()
    })
}

//讲座评论列表    params*(lecture_id,page,limit)
export function getLecture_comment_list(params) {
    return request({ 
        url:'/api/lecture/comment_list',
        method: 'GET',
        params,
        headers: getHeader()
    })
}

//我的讲座列表   params*(page,limit)
export function getLecture_my_list(params) {
    return request({ 
        url:'/api/lecture/my_list',
        method: 'GET',
        params,
        headers: getHeader()
    })
}

//讲座签到   params*(lecture_id,sign_in_code)
export function getLecture_sign_int(params) {
    return request({ 
        url:'/api/lecture/sign_in',
        method: 'POST',
        data:params,
        headers: getHeader()
    })
}

//讲座评论   params*(lecture_id,overall,express,effect,content)
export function getLecture_evaluate(params) {
    return request({ 
        url:'/api/lecture/evaluate',
        method: 'POST',
        data:params,
        headers: getHeader()
    })
}

//阅览室分类   
export function getReading_category() {
    return request({ 
        url:'/api/reading_room/category',
        method: 'GET',
        headers: getHeader()
    })
}

//阅览室列表     params*(page,limit,category_id)
export function getReading_list(params) {
    return request({ 
        url:'/api/reading_room/list',
        method: 'GET',
        params,
        headers: getHeader()
    })
}

//阅览室预约列表     params*(id,date)
export function getReading_apmlist(params) {
    return request({ 
        url:'/api/reading_room/apm_list',
        method: 'GET',
        params,
        headers: getHeader()
    })
}

//阅览室预约     params*(id,apm_date,start_time,end_time)
export function getReading_apm(params) {
    return request({ 
        url:'/api/reading_room/apm',
        method: 'POST',
        data: params,
        headers: getHeader()
    })
}

//阅览室取消预约     params*(id)
export function getReading_cancel(params) {
    return request({ 
        url:'/api/reading_room/cancel',
        method: 'POST',
        data: params,
        headers: getHeader()
    })
}

//研讨室列表     params*(date)
export function getSeminar_list(params) {
    return request({ 
        url:'/api/seminar_room/list',
        method: 'GET',
        params,
        headers: getHeader()
    })
}

//研讨室使用规则     params*({id})
export function getSeminar_rule(params) {
    return request({ 
        url:'/api/seminar_room/use_rule/'+params,
        method: 'GET',
        headers: getHeader()
    })
}

//研讨室预约     params*(seminar_room_id,apm_date,start_time,start_time,end_time,apm_desc)
export function getSeminar_apm(params) {
    return request({ 
        url:'/api/seminar_room/apm',
        method: 'POST',
        data: params,
        headers: getHeader()
    })
}

//我的研讨室预约列表    params*(page,limit,status)
export function getSeminar_my_apm(params) {
    return request({ 
        url:'/api/seminar_room/my_apm',
        method: 'GET',
        params,
        headers: getHeader()
    })
}

//研讨室取消预约    params*(id)
export function getSeminar_cancel(params) {
    console.log("取消："+params);
    return request({ 
        url:'/api/seminar_room/cancel',
        method: 'POST',
        data: params,
        headers: getHeader()
    })
}

//研讨室预约待审列表   params*(page,limit,type)
export function getSeminar_examine_list(params) {
    return request({ 
        url:'/api/seminar_room/examine_list',
        method: 'GET',
        params,
        headers: getHeader()
    })
}

//预约审核   params*(id,status)
export function getSeminar_examine(params) {
    return request({ 
        url:'/api/seminar_room/examine',
        method: 'POST',
        data: params,
        headers: getHeader()
    })
}

//获取x-services的session   HEADER--改明文
export function getSession() {
    // const headers = JSON.parse(sessionStorage.getItem('token'))     
    return request({ 
        url:'/api/book/get_session',
        method: 'GET',
        headers: getHeader()
    })
}

//图书预约记录      params*(book_name,bor_id)
export function getLook_apm(data) {
    return request({ 
        url:'/api/book/apm',
        method: 'POST',
        data,
        headers: getHeader()
    })
}

//我的页面   home
export function getMy_num(token) {
    // const headers = JSON.parse(sessionStorage.getItem('token'))     //暂时-第一页面无法拿到header
    return request({ 
        url:'/api/user/my',
        method: 'GET',
        headers: token
    })
}

//我的预约列表   in library
export function getReading_room(params) {
    return request({ 
        url:'/api/reading_room/my_apm_list',
        method: 'GET',
        params,
        headers: getHeader()
    })
}

//预约详情library   params=/{id}
export function getReading_detail(params) {
    return request({ 
        url:'/api/reading_room/apm_detail/'+params+"?time="+Date.now(),
        method: 'GET',
        headers: getHeader()
    })
}

//预约确认library   params(id)
export function getReading_confirm(data) {
    return request({ 
        url:'/api/reading_room/confirm',
        method: 'POST',
        data:data,
        headers: getHeader()
    })
}

//我的评价列表   params(page,limit)
export function my_evaluate(params) {
    return request({ 
        url:'/api/lecture/my_evaluate',
        method: 'GET',
        params,
        headers: getHeader()
    })
}

//文章列表-关键词搜索   params(is_rand,keyword)
export function article_keyword(params) {
    return request({ 
        url:'/api/article/keyword',
        method: 'GET',
        params,
        headers: getHeader()
    })
}


//用户分享  微信分享
export function user_jssdk(params) {
    return request({ 
        url:'/api/user/jssdk',
        method: 'POST',
        data: params,
        // headers: getHeader()
    })
}


// WEBPACK FOOTER //
// ./src/utils/api.js